import React, { createContext, useContext, useState } from 'react';

interface AnalysisPendingContextType {
  analysisPending: boolean;
  setAnalysisPending: (pending: boolean) => void;
}

const AnalysisPendingContext = createContext<AnalysisPendingContextType | undefined>(undefined);

export const AnalysisPendingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [analysisPending, setAnalysisPending] = useState(false);
  return (
    <AnalysisPendingContext.Provider value={{ analysisPending, setAnalysisPending }}>
      {children}
    </AnalysisPendingContext.Provider>
  );
};

export function useAnalysisPending() {
  const context = useContext(AnalysisPendingContext);
  if (!context) {
    throw new Error('useAnalysisPending debe usarse dentro de AnalysisPendingProvider');
  }
  return context;
} 